import { useContext } from "react";
import AppContext from "../components/context/app-context";

export const useMapContext = () => {
  const context = useContext(AppContext);

  return context;
};
